(ns common.schema.entities.decision-participant
  (:require
   [common.schema.schema-utils :as su]
   [common.schema.entities.decision-participant-options :as decision-participant-options]))

(def schema
  (concat
   (su/single-ref-field :decision-participant/person
                        "Person"
                        [:entity.type/person :entity.type/account]
                        {:authorization su/access-user-user
                         :default-field-visibility :in-use})

   (su/keyword-field :decision-participant/attendance
                     "Attendance"
                     decision-participant-options/attendance-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})

   (su/option-field-multi :decision-participant/role
                          "Role"
                          {:authorization su/access-user-user
                           :default-field-visibility :in-use})

   (su/keyword-field :decision-participant/vote
                     "Vote"
                     decision-participant-options/vote-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})

   (su/boolean-field :decision-participant/signatory
                     "Signatory"
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})

   (su/text-multiline-field :decision-participant/notes
                            "Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})))

(def required-fields
  #{:decision-participant/person
    :decision-participant/attendance
    :decision-participant/role})
